import angular from 'angular';
import { PayrollFinancialsDashboardComponent } from './payroll-financials-dashboard.component';
import { PayrollFinancialsProgramSummaryComponent } from './payroll-financials-program-summary.component';
import { PayrollFinancialsDetailComponent } from './payroll-financials-detail.component';

export const PayrollFinancialsModule = angular
    .module("apex.mainApp.payrollFinancials", [])
    .component("apexPayrollFinancialsDashboard", PayrollFinancialsDashboardComponent)
    .component("apexPayrollFinancialsProgramSummary", PayrollFinancialsProgramSummaryComponent)
    .component("apexPayrollFinancialsDetail", PayrollFinancialsDetailComponent)
    .name;
